(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6808],{

/***/ 79105:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/suppliers/tenders-auctions/[id]/[slug]",
      function () {
        return __webpack_require__(2267);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(828);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(35944);
/* harmony import */ var babel_plugin_superjson_next_tools__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23544);
/* harmony import */ var babel_plugin_superjson_next_tools__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(babel_plugin_superjson_next_tools__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51813);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36492);
/* harmony import */ var styles_jss_Layout_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48231);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(53156);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(87357);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(67720);
/* harmony import */ var components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11232);
/* harmony import */ var components_PagesComponents__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50348);
/* harmony import */ var utils_helperFunction__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18991);
/* harmony import */ var services_tenders_auctions_api__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11139);













function TendersAuctionsPage() {
    var ref;
    var ref1 = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)(), locale = ref1.locale, query = ref1.query;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)("article").t;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
    var ref2 = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_9__/* .useQuery */ .a)([
        "tender-".concat(query.id)
    ], function() {
        return (0,services_tenders_auctions_api__WEBPACK_IMPORTED_MODULE_7__/* .getTAList */ .Y)(locale, {
            filters: {
                slug: {
                    $eq: query.slug
                },
                id: {
                    $eq: query.id
                }
            }
        });
    }), _data = ref2.data, _data1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_data.data, 1), tenderDetails = _data1[0];
    if (!tenderDetails) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(components__WEBPACK_IMPORTED_MODULE_4__/* .Redirect */ .l_, {});
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(components_PagesComponents__WEBPACK_IMPORTED_MODULE_5__/* .PageContainer */ ._, {
        seo_info: {
            title: tenderDetails.attributes.title,
            description: tenderDetails.attributes.short_description,
            image: (ref = tenderDetails.attributes.thumbnail.data) === null || ref === void 0 ? void 0 : ref.attributes.formats
        },
        banner: tenderDetails.attributes.thumbnail,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(styles_jss_Layout_styles__WEBPACK_IMPORTED_MODULE_3__/* .DetailsPage */ .kl, {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                sx: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                    mt: "40px"
                }, theme.breakpoints.down("md"), {
                    px: "0",
                    mt: "0"
                }),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(styles_jss_Layout_styles__WEBPACK_IMPORTED_MODULE_3__/* .MainArticle */ ._$, {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(styles_jss_Layout_styles__WEBPACK_IMPORTED_MODULE_3__/* .ContainerArticle */ .L_, {
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(styles_jss_Layout_styles__WEBPACK_IMPORTED_MODULE_3__/* .ArticleHeader */ .K3, {
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)("h1", {
                                        className: "title",
                                        children: tenderDetails.attributes.title
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                        sx: {
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(components__WEBPACK_IMPORTED_MODULE_4__/* .DateStamp */ .Ko, {
                                                date: tenderDetails.attributes.datetime,
                                                time: true
                                            }),
                                            !!tenderDetails.attributes.end_datetime && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(components__WEBPACK_IMPORTED_MODULE_4__/* .EndDateStamp */ .Kq, {
                                                date: tenderDetails.attributes.end_datetime
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                sx: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                                    my: "60px"
                                }, theme.breakpoints.down("md"), {
                                    my: "20px",
                                    mx: "16px"
                                })
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(components__WEBPACK_IMPORTED_MODULE_4__/* .PostContent */ .C2, {
                                description: tenderDetails.attributes.description
                            }),
                            !(0,utils_helperFunction__WEBPACK_IMPORTED_MODULE_6__/* .isEmpty */ .xb)(tenderDetails.attributes.attachment) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)("div", {
                                className: "attachment",
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)("p", {
                                        children: [
                                            t("tender.attachment"),
                                            " :"
                                        ]
                                    }),
                                    tenderDetails.attributes.attachment.map(function(item) {
                                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)("a", {
                                            className: "downloadFile",
                                            href: "https://websiteapidev.aryasasol.com" + item.file.data.attributes.url,
                                            download: true,
                                            children: item.file_name
                                        }, item.id);
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
}
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,babel_plugin_superjson_next_tools__WEBPACK_IMPORTED_MODULE_0__.withSuperJSONPage)(TendersAuctionsPage));


/***/ }),

/***/ 11139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ getTAList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35559);
/* harmony import */ var _qsStringify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55063);



var getTAList = function(locale, queries) {
    var query = (0,_qsStringify__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        populate: [
            "thumbnail",
            "categories.sort",
            "attachment.file"
        ],
        sort: [
            "datetime:desc"
        ]
    }, queries));
    return _api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/tenders-and-auctions?locale=".concat(locale, "&").concat(query)).then(function(res) {
        return res.data;
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(79105); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);